import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DefaultRadioButton from './RadioButton';
import { withVDSManager } from '@vds-core/utilities';
import { showError } from '../utils';
var defaultProps = {
  defaultValue: null,
  className: null,
  error: false,
  RadioButton: DefaultRadioButton,
  errorState: false,
  onChange: function onChange() {},
  ariaLabel: '',
  inverted: false
};
var propTypes = {
  /**
   * @ignore If provided, Radio Button components will be rendered based on this data.
   * @typeName radioButtonData
   */
  data: PropTypes.arrayOf(PropTypes.shape({
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    onChange: PropTypes.func
  })),

  /**
   * @deprecated data
   */
  children: PropTypes.node,

  /**
   * If provided, the Radio component with a corresponding value will be selected when the RadioGroup is rendered.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * If provided, the Radio component with a corresponding value will be selected and the selection of the RadioButtonGroup will be controlled.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Optional function that is called when Radio component is selected. If provided, it will be called with a DOM form event object from selected Radio.
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Boolean or a Function that returns a boolean value that determines if component should show the error state/error message. Function receives the 'event' object  on input change.
   */
  error: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),

  /**
   * @ignore
   * Prop that when passed, applies the error state on all RadioButtons if any RadioButton has error.
   */
  errorState: PropTypes.bool,

  /**
   * @ignore
   * If provided, a new RadioButton component will render within the group.
   */
  RadioButton: PropTypes.func,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,

  /**
   * Allows for an aria-label to be passed to the RadioButtonGroup component
   */
  ariaLabel: PropTypes.string,

  /**
   * If provided the RadioButtons will be rendered in inverted color scheme.
   */
  inverted: PropTypes.bool
};
var RadioButtonGroupWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "RadioButtonGroupWrapper",
  componentId: "sc-15mt7ao-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"])));

var RadioButtonGroup = /*#__PURE__*/function (_Component) {
  _inherits(RadioButtonGroup, _Component);

  var _super = _createSuper(RadioButtonGroup);

  function RadioButtonGroup() {
    var _this2;

    _classCallCheck(this, RadioButtonGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "state", {
      selectedRadio: _this2.props.defaultValue || _this2.props.value,
      error: _this2.props.error === true
    });

    _defineProperty(_assertThisInitialized(_this2), "handleRadioSelect", function (e) {
      _this2.props.onChange && _this2.props.onChange(e);

      if (!_this2.props.hasOwnProperty('value')) {
        _this2.setState({
          selectedRadio: e.target.value
        });
      } // check for error on select


      var _this = _assertThisInitialized(_this2);

      showError(e, _this);
    });

    return _this2;
  }

  _createClass(RadioButtonGroup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.setState({
          selectedRadio: this.props.value
        });
      }
    }
  }, {
    key: "renderRadios",
    value: // Maintain backwards compatibility
    function renderRadios() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          error = _this$props.error,
          errorState = _this$props.errorState,
          inverted = _this$props.inverted;
      return React.Children.map(children, function (child, index) {
        return /*#__PURE__*/React.cloneElement(child, {
          key: index + 1,
          checked: _this3.state.selectedRadio === child.props.value,
          selected: _this3.state.selectedRadio === child.props.value,
          onChange: _this3.handleRadioSelect,
          error: errorState ? error : child.props.error,
          inverted: inverted
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children,
          data = _this$props2.data,
          errorProp = _this$props2.error,
          RadioButton = _this$props2.RadioButton,
          errorState = _this$props2.errorState,
          id = _this$props2.id,
          ariaLabel = _this$props2.ariaLabel,
          inverted = _this$props2.inverted; // Error state has preference
      // Necessary to handle error change on storybook

      var error = this.state.error || typeof errorProp === 'boolean' && errorProp;
      return /*#__PURE__*/React.createElement(Fragment, null, children && /*#__PURE__*/React.createElement(RadioButtonGroupWrapper, {
        id: id,
        className: this.props.className,
        role: "radiogroup",
        "aria-label": ariaLabel
      }, this.renderRadios()), data && /*#__PURE__*/React.createElement(RadioButtonGroupWrapper, {
        id: id,
        role: "radiogroup",
        "aria-label": ariaLabel
      }, data.map(function (child, index) {
        var inputId = child.inputId;
        return /*#__PURE__*/React.createElement(RadioButton, _extends({}, child, {
          id: id,
          inputId: inputId,
          key: ++index,
          name: child.name,
          disabled: child.disabled,
          error: _this4.state.selectedRadio ? undefined : errorState ? error : child.error,
          value: child.value,
          children: child.children,
          checked: _this4.state.selectedRadio === child.value,
          selected: _this4.state.selectedRadio === child.value,
          onChange: _this4.handleRadioSelect,
          tabIndex: _this4.state.selectedRadio ? 0 : index === 0 ? 0 : -1,
          inverted: inverted
        }));
      })));
    }
  }]);

  return RadioButtonGroup;
}(Component);

RadioButtonGroup.defaultProps = defaultProps;
RadioButtonGroup.propTypes = propTypes;
export default withVDSManager(RadioButtonGroup);